import { ValidationMessage, ValidationProps } from 'ui/common/validation/types';

const getUpdatedValidationMessages = (
  messages: ValidationMessage[],
  parameters: { [key: string]: number | string }) =>
  messages.filter(message =>
    Object.keys(parameters).length === 0 || Object.keys(parameters).some(key =>
      message.parameters[key] !== parameters[key])
  );

export const clearValidation = (
  validation: { [key: string]: ValidationProps },
  formName: string,
  parameters?: { [key: string]: number | string }
) => {

  if (!validation || !validation[formName]) {
    return validation;
  }

  if (parameters === undefined) {
    return {
      ...validation,
      [formName]: undefined
    };
  }

  return {
    ...validation,
    [formName]: {
      level: validation[formName].level,
      messages: getUpdatedValidationMessages(validation[formName].messages, parameters)
    }
  };
};
